import * as React from 'react';
import { useRefinementList } from 'react-instantsearch';
import { AccordionItem } from '@grandvisionhq/common';
import { filterFacetOption } from '../../utils/filter-facet-option.js';
import { orderFacetOptions } from '../../utils/order-facet-options.js';
import RefinementItem from '../RefinementItem/RefinementItem.js';

const ConnectedFacetContainerMobile = ({ facet , onChange , label , attribute , limit ,  })=>{
    const { items , refine , isFromSearch  } = useRefinementList({
        attribute,
        limit
    });
    const sortedItems = React.useMemo(()=>{
        if (!items.length && !isFromSearch) {
            return [];
        }
        return orderFacetOptions({
            facet,
            items
        }).filter((item)=>filterFacetOption(item, facet)
        );
    }, [
        facet,
        items,
        isFromSearch
    ]);
    if (!items.length && !isFromSearch) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(AccordionItem, {
        id: facet.id,
        label: label,
        headingLevel: "h3"
    }, /*#__PURE__*/ React.createElement("fieldset", null, sortedItems.map((item)=>/*#__PURE__*/ React.createElement(RefinementItem, {
            key: item.label,
            item: item,
            facet: facet,
            onRefine: refine,
            onChange: onChange
        })
    )));
};

export { ConnectedFacetContainerMobile };
//# sourceMappingURL=ConnectedFacetContainerMobile.js.map
